import React               from 'react';
import classnames          from 'classnames';

const SelectCellBomParameter = (props) => {
  const id = `bom_parameters[${props.id}]`
  return (
    <th className="identify-col">
      <div className="sel">
        <select id={id}
          name={id} 
          onChange={e => props.onChange(props.id, e.target.value)} >
          <option value="">IDENTIFY</option>";
          <option value="mpn"> MFG PART # * </option>
          <option value="reference_designator"> REF DESIGNATOR * </option>
          <option value="qty_per_board"> QTY PER BOARD (Optional) </option>
          <option value="manufacturer"> MFG (Optional) </option>
          <option value="vendor_part"> VENDOR PART </option>
          <option value="vendor"> VENDOR (Optional) </option>
          <option value="description"> DESCRIPTION (Optional) </option>
          <option value="dnp"> Do not populate? </option>
        </select>
      </div>
    </th>
  )
}

export default SelectCellBomParameter;